<template>
  <div>
    <div class="floor white-text" v-if="floorSwitch">
      <a href="https://www.qx.com/Account/Login" v-if="cart" to="/cart" class="floor-cart mc-flex mc-flex-justify-center" title="购物车">
        <img src="@/assets/images/cart.png" width="21px" height="19px" alt />
      </a>
      <slot name="floor"></slot>
      <!-- <template v-if="home">
        <div @click="goTool"  class="tool" :href="`#tool${index}`" v-for="(item, index) in 3" :key="index">工具/耗材</div>
      </template>-->

      <el-backtop title="返回顶部">
        <img src="@/assets/images/back-top.png" width="22px" height="22px" alt />
      </el-backtop>
    </div>
  </div>
</template>

<script>
export default {
  props: ["home", "cart"],
  data() {
    return {
      floorSwitch: false,
    };
  },

  // components: {},

  // computed: {},

  mounted() {
    window.addEventListener("scroll", this.getScrollPosition, false);
  },

  methods: {
    getScrollPosition(e) {
      let top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      top > 200 ? (this.floorSwitch = true) : (this.floorSwitch = false);
    },
  },
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";

.floor {
  width: 40px;
  background: @4a;
  border-radius: 15px;
  /* padding-bottom: 10px; */
  position: fixed;
  right: 15px;
  bottom: 200px;
  z-index: 100001;
  a,
  .tool {
    display: block;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    color: @white;
    border-bottom: 1px solid @ccc;
    &:hover {
      background: @yellow;
      color: @gray3;
    }
    &.back-top {
      background: none;
      border-bottom: none;
      &:hover {
        background: none;
        color: @white;
      }
    }
  }
  .floor-cart {
    display: flex;
    height: auto;
    padding: 10px 0;
    border-bottom: 1px solid @ccc;
    &:hover {
      background: none;
    }
  }
  /deep/.el-backtop {
    position: unset;
    background: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Floor.vue